import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const createSupportConfig = createAsyncThunk('supportConfig/create',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axiosPrivate.post(api.supportConfig.createSupportConfig, payload);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
        }
    })

export const fetchSupportConfig = createAsyncThunk('supportConfig/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosPrivate.get(api.supportConfig.getAllSupportConfig);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
        }
    })

export const createHRAssignment = createAsyncThunk('HRAssignment/create',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await axiosPrivate.post(api.supportConfig.createHRAssignment, payload);
            return response.data.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
        }
    })

export const fetchHRAssignment = createAsyncThunk('HRAssignment/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosPrivate.get(api.supportConfig.getAllHRAssignment);
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
        }
    })

const supportConfigSlice = createSlice({
    name: 'supportConfig',
    initialState: {
        supportConfig: [],
        assignment: [],
        configStatus: 'idle',
        assignmentStatus: 'idle',
        configLoading: false,
        assignmentLoading: false,
        configError: null,
        assignmentError: null
    },
    reducers: {
        clearConfigErrors: (state) => {
            state.configError = null;
            state.assignmentError = null;
        }
    },
    extraReducers: (builders) => {
        builders.
            addCase(createSupportConfig.pending,
                (state) => {
                    state.configStatus = 'loading';
                    state.configLoading = true;
                    state.configError = null;
                })
            .addCase(createSupportConfig.fulfilled,
                (state, action) => {
                    state.configStatus = 'succeeded';
                    state.configLoading = false;
                    state.supportConfig.push(action.payload);
                })
            .addCase(createSupportConfig.rejected,
                (state, action) => {
                    state.configStatus = 'failed';
                    state.configLoading = false;
                    state.configError = action.payload;
                })
            .addCase(fetchSupportConfig.pending,
                (state) => {
                    state.configStatus = 'loading';
                    state.configLoading = true;
                    state.configError = null;
                })
            .addCase(fetchSupportConfig.fulfilled,
                (state, action) => {
                    state.configStatus = 'succeeded';
                    state.configLoading = false;
                    state.supportConfig = action.payload || [];
                })
            .addCase(fetchSupportConfig.rejected,
                (state, action) => {
                    state.configStatus = 'failed';
                    state.configLoading = false;
                    state.configError = action.payload;
                })
            .addCase(createHRAssignment.pending,
                (state) => {
                    state.assignmentStatus = 'loading';
                    state.assignmentLoading = true;
                    state.assignmentError = null;
                })
            .addCase(createHRAssignment.fulfilled,
                (state, action) => {
                    state.assignmentStatus = 'succeeded';
                    state.assignmentLoading = false;
                    if (state.assignment && Array.isArray(state.assignment.data)) {
                        state.assignment.data.push(action.payload);
                    }
                })
            .addCase(createHRAssignment.rejected,
                (state, action) => {
                    state.assignmentStatus = 'failed';
                    state.assignmentLoading = false;
                    state.assignmentError = action.payload;
                })
            .addCase(fetchHRAssignment.pending,
                (state) => {
                    state.assignmentStatus = 'loading';
                    state.assignmentLoading = true;
                    state.assignmentError = null;
                })
            .addCase(fetchHRAssignment.fulfilled,
                (state, action) => {
                    state.assignmentStatus = 'succeeded';
                    state.assignmentLoading = false;
                    state.assignment = action.payload || [];
                })
            .addCase(fetchHRAssignment.rejected,
                (state, action) => {
                    state.assignmentStatus = 'failed';
                    state.assignmentLoading = false;
                    state.assignmentError = action.payload;
                });
    }
})

export const { clearConfigErrors } = supportConfigSlice.actions;
export default supportConfigSlice.reducer;